import React, { useState } from "react";
import moment from "moment";
import Confirm from "../../molecules/Confirm";
import { trackPromise } from "react-promise-tracker";
import { apiDeleteFile, apiPostFiles } from "../../../utils/queries";
import "./RequestFilesForm.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashAlt, faFile } from "@fortawesome/free-solid-svg-icons";

import { Label } from "reactstrap";

export const RequestFilesForm = (props) => {
  const [toggleConfirmFileDelete, setToggleConfirmFileDelete] = useState(false);
  const [selectedFile, setSelectedFile] = useState({});

  const addAlert = (message, color) => props.addAlert?.(message, color);

  const onDeleteFile = async (file) => {
    setSelectedFile(file);
    setToggleConfirmFileDelete(!toggleConfirmFileDelete);
  };

  const selectedFilesChanged = async (e) => {
    let form = new FormData();

    form.append("BankDataId", props.bankDataId);
    form.append("RequestId", props.requestId);
    form.append("Token", props.token || "");
    form.append("Source", "Request Portal");

    for (var index = 0; index < e.target.files.length; index++) {
      var file = e.target.files[index];

      for (var i = 0; i < props?.fileList.length; i++) {
        var existingFile = props?.fileList[i];

        if (existingFile.name === file.name) {
          addAlert("Files with same name already added", "danger");
          return;
        }
      }

      form.append("file", file);
    }
    try {
      let files = await trackPromise(apiPostFiles(form));
      props.setFileList([...props?.fileList, ...files.data]);
      addAlert(`Files was uploaded`, "success");
    } catch (error) {
      addAlert(
        `Uploading file failed. Please contact Hafnia: ${error.message || error}`,
        "danger"
      );
    }
  };

  const onDeleteFileConfirmed = async () => {
    try {
      await apiDeleteFile(props.token, selectedFile.fileName);
      addAlert("File deleted", "success");
      props.setFileList(
        props?.fileList.filter(
          (item) => item.fileName !== selectedFile.fileName
        )
      );
    } catch (error) {
      addAlert("Could not delete file. Please contact Hafnia.", "danger");
    }
  };

  const filteredFiles = props?.fileList?.filter(
    (file) => file.bankDataId === props.bankDataId
  );

  return (
    <>
      {/* Uploaded files list */}
      {filteredFiles && filteredFiles.length > 0 && (
        <div className="rd-file-list">
          {filteredFiles.map((file, index) => {
            const source = file.source || "Request Portal";
            const date = file.inserted ? moment(file.inserted).format("DD-MM-YYYY HH:mm") : null;
            const meta = [source, date].filter(Boolean).join(" · ");
            return (
              <div key={index} className="rd-file-item">
                <div className="rd-file-item__icon">
                  <FontAwesomeIcon icon={faFile} />
                </div>
                <div className="rd-file-item__info">
                  <a href={file.url} target="_blank" rel="noopener noreferrer" className="rd-file-item__name">
                    {file.displayName}
                  </a>
                  {meta && <span className="rd-file-item__meta">{meta}</span>}
                </div>
                <button
                  type="button"
                  className="rd-file-item__delete"
                  onClick={() => onDeleteFile(file)}
                  title="Delete"
                  aria-label="Delete file"
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </button>
              </div>
            );
          })}
        </div>
      )}

      <div className="rff-upload">
        <Label htmlFor={"file-upload-" + props.name} className="rff-dropzone">
          <span className="rff-dropzone__icon">
            <FontAwesomeIcon icon={faPlus} />
          </span>
          <span className="rff-dropzone__text">Add File</span>
          <span className="rff-dropzone__hint">PDF, JPG, PNG · max 10 MB</span>
        </Label>
        <input
          id={"file-upload-" + props.name}
          className="rff-file-input"
          type="file"
          onChange={selectedFilesChanged}
          multiple
        />
      </div>

      <Confirm
        onConfirm={onDeleteFileConfirmed}
        text="Are you sure you want to delete this?"
        toggle={toggleConfirmFileDelete}
        setToggle={setToggleConfirmFileDelete}
      />
    </>
  );
};
